/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState , useMemo} from "react";

import Card from "components/card";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
import { format } from "date-fns";
import { useGlobalContext } from "context/globalContext";
import Loader from "components/loader/Loader";
import { getSysPromptsAPI ,getFilterSysPromptsAPI} from "Api/sysPromptsAPI";
import CreateSysPrompts from "../createSysPrompts/createSysPrompts";
import EditOrDeleteSysPrompt from "../edit-or-delete-sysPrompts/editOrDeleteSysPrompts";
import "./systemprompts.styles.css";
import FilterDropdown from "../filter-dropdown/FilterDropdown";
import { consoleLog } from "helpers";

const SystemPromptsTable = () => {
  const {
    fetchSysPrompts,
    setFetchSysPrompts,
    filterData,
    getFilterdata,
    setSysPromptsFormData,
    initialSysPromptsFormState,
    setIsOpenSystemPromptsPreviewModal,
  } = useGlobalContext();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterTableData, setFilterTableData] = useState([]);
  const [promptFragmentsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
  const [totalPages, setTotalPages] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);

  // const getPromptFragments = useCallback(async () => {
  //   const token = localStorage.getItem("jwtToken");
  //   const response = await getPromptFragmentsAPI(() => {}, token);
  //   if (response) {
  //     setPromptFragmentsData(response);
  //   }
  // }, []);

  const debounceSearch = useMemo(() => {
    let timeoutId;
    return function (value) {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setSearchQuery(value);
        setPageIndex(0);
      }, 300);
    };
  }, []);

  const selectedFilterArray = Object?.keys(selectedFilters)?.filter(
    (key) => selectedFilters[key] !== ""
  );

  const getFilterSysPrompts = useCallback(async () => {
    if (!searchQuery && selectedFilterArray?.length === 0) return;
    let payload;
    if (searchQuery && selectedFilterArray?.length > 0) {
      const filterObj = Object?.keys(selectedFilters)
        ?.filter((key) => selectedFilters[key] !== "")
        ?.reduce((acc, key) => ({ ...acc, [key]: selectedFilters[key] }), {});
      payload = filterObj?.status
        ? {
            searchQuery,
            ...{ ...filterObj, status: filterObj?.status === "Active" },
          }
        : {
            searchQuery,
            ...filterObj,
          };
    }
    if (searchQuery && selectedFilterArray?.length === 0)
      payload = {
        searchQuery,
      };
    if (!searchQuery && selectedFilterArray?.length > 0) {
      const filterObj = Object?.keys(selectedFilters)
        ?.filter((key) => selectedFilters[key] !== "")
        ?.reduce((acc, key) => ({ ...acc, [key]: selectedFilters[key] }), {});
      payload = filterObj?.status
        ? { ...{ ...filterObj, status: filterObj?.status === "Active" } }
        : {
            ...filterObj,
          };
    }
    const token = localStorage.getItem("jwtToken");

    const skip = pageIndex * 10;
    const limit = 10;

    try {
      const response = await getFilterSysPromptsAPI(
        { searchQuery, pageIndex, limit, skip },
        payload,
        setIsLoading,
        token
      );
      if (response) {
        setFilterTableData(response.data);
        setTotalPages(response.totalPages);
        setFetchSysPrompts(false);
      } else {
        setFilterTableData([]);
      }
    } catch (error) {
      console.error("Error fetching filtered config:", error);
    }
  }, [
    searchQuery,
    pageIndex,
    selectedFilterArray?.length,
    selectedFilters,
    setFetchSysPrompts,
  ]);

  const getSysPrompts = useCallback(async () => {
    if (!searchQuery && selectedFilterArray.length === 0) {
      const token = localStorage.getItem("jwtToken");
      const skip = 10;

      try {
        setIsLoading(true);
        const response = await getSysPromptsAPI(
          {
            skip,
            pageIndex,
          },
          setIsLoading,
          token
        );
        if (response && response.data) {
          setTableData(response.data);
          setTotalPages(response?.pagination?.totalPages || 0);
          setFetchSysPrompts(false);
        } else {
          setTableData([]);
        }
      } catch (error) {
        console.error("Error fetching destinations:", error);
      }
    }
  }, [searchQuery, pageIndex, selectedFilterArray?.length, setFetchSysPrompts]);

  const columnsData = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Key",
        accessor: "key",
      },
      {
        Header: "Version",
        accessor: "version",
      },
      {
        Header: "Value",
        accessor: "value",
      },
      {
        Header: "Status",
        accessor: "isActive",
        sortType: (rowA, rowB) => {
          const a = rowA.values.isActive;
          const b = rowB.values.isActive;
          if (a === b) return 0;
          return a ? -1 : 1;
        },
      },
      {
        Header: "Comment",
        accessor: "comment",
      },

      {
        Header: "Actions",
        accessor: "actions",
      },
    ],
    []
  );

  const columns = useMemo(() => columnsData, [columnsData]);

  const tableInstance = useTable(
    {
      columns,
      data:
        searchQuery || selectedFilterArray.length > 0
          ? filterTableData
          : tableData,

      manualPagination: true,
      pageCount: totalPages,
      pageIndex,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,

    gotoPage,
  } = tableInstance;

  const filters = filterData?.find(
    (filter) => filter?.table === "prompt"
  )?.filters;

  const handleOpenValuesPreviewModal = useCallback(
    (cell) => {
      setSysPromptsFormData(
        cell?.row?.original
          ? {
              ...cell.row.original,
              isActive: cell.row.original?.isActive ? "active" : "inactive",
            }
          : {
              ...initialSysPromptsFormState,
              isActive: initialSysPromptsFormState?.isActive
                ? "active"
                : "inactive",
            }
      );
      setIsOpenSystemPromptsPreviewModal(true);
    },
    [
      setSysPromptsFormData,
      initialSysPromptsFormState,
      setIsOpenSystemPromptsPreviewModal,
    ]
  );

  const handlePageChange = (direction) => {
    if (direction === "next" && pageIndex < totalPages - 1) {
      const nextIndex = pageIndex + 1;
      setPageIndex(nextIndex);
      gotoPage(nextIndex);
    } else if (direction === "previous" && pageIndex > 0) {
      const prevIndex = pageIndex - 1;
      setPageIndex(prevIndex);
      gotoPage(prevIndex);
    }
  };

  useEffect(() => {
    const shouldFilter = searchQuery || selectedFilterArray.length > 0;
    if (shouldFilter) {
      getFilterSysPrompts();
    } else {
      getSysPrompts();
    }
  }, [
    searchQuery,
    selectedFilters,
    pageIndex,
    getFilterSysPrompts,
    getSysPrompts,
  ]);

  useEffect(() => {
    if (fetchSysPrompts) {
      const shouldFilter = searchQuery || selectedFilterArray.length > 0;

      if (shouldFilter) {
        getFilterSysPrompts();
      } else {
        getSysPrompts();
      }

      getFilterdata();
      setFetchSysPrompts(false);
    }
  }, [
    fetchSysPrompts,
    searchQuery,
    selectedFilters,
    selectedFilterArray?.length,
    getSysPrompts,
    getFilterSysPrompts,
    getFilterdata,
    setFetchSysPrompts,
  ]);

  return (
    <Card extra={"w-full h-auto p-4 sm:overflow-x-auto"}>
      <div className="relative flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center ">
        <div className="flex w-full flex-col gap-3 sm:max-w-lg sm:flex-row">
          <div className="relative w-full sm:w-64">
            <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2 text-gray-400">
              🔍
            </span>
            <input
              type="search"
              className="w-full rounded-md border border-gray-300 py-2 pl-8 pr-2 text-sm transition-all duration-300 ease-in-out hover:border-blue-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:!bg-gray-10 dark:text-white"
              placeholder=" Search"
              onChange={(e) => {
                e.preventDefault();
                debounceSearch(e.target.value);
              }}
            />
          </div>

          {filters?.length > 0 && (
            <FilterDropdown
              filters={filters}
              onFilterSelect={(selectedFilters) => {
                consoleLog(["Selected filters:", selectedFilters]);
                setSelectedFilters(selectedFilters);
                setPageIndex(0);
              }}
              finalFilters={selectedFilters}
            />
          )}
        </div>

        <CreateSysPrompts promptFragmentsData={promptFragmentsData} />
      </div>

      <div className="mt-4 h-full overflow-x-scroll xl:overflow-auto">
        {isLoading && tableData.length === 0 && (
          <div className="flex h-[400px] w-full items-center justify-center">
            <Loader />
          </div>
        )}
        {!isLoading &&
          (searchQuery || selectedFilterArray?.length > 0) &&
          filterTableData.length === 0 && (
            <span className="block w-full text-center">No data found.</span>
          )}
        {!isLoading && tableData.length === 0 && (
          <span className="block w-full text-center">No data found.</span>
        )}
        {((!!tableData.length &&
          !searchQuery &&
          !selectedFilterArray?.length) ||
          (!!filterTableData.length &&
            (searchQuery || selectedFilterArray?.length > 0))) && (
          <table {...getTableProps()} className="w-full">
            <thead>
              {headerGroups.map((headerGroup, index) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                  {headerGroup.headers.map((column, index) => {
                    if (column.Header === "Value") {
                      return (
                        <th
                          key={index}
                          className="border-b border-gray-200 pr-20 pb-[10px] text-start dark:!border-navy-700 "
                        >
                          <p className="w-72 text-xs tracking-wide text-gray-600">
                            {column.render("Header")}
                          </p>
                        </th>
                      );
                    }
                    if (column.Header === "Version") {
                      return (
                        <th
                          key={index}
                          className="w-10 border-b border-gray-200 pr-10 pb-[10px] text-start dark:!border-navy-700 "
                        >
                          <p className="w-10 text-xs tracking-wide text-gray-600">
                            {column.render("Header")}
                          </p>
                        </th>
                      );
                    }
                    if (column.Header === "Order") {
                      return (
                        <th
                          key={index}
                          className="w-10 border-b border-gray-200 pr-10 pb-[10px] text-start dark:!border-navy-700 "
                        >
                          <p className="w-10 text-xs tracking-wide text-gray-600">
                            {column.render("Header")}
                          </p>
                        </th>
                      );
                    }
                    if (column.Header === "Status") {
                      return (
                        <th
                          key={index}
                          className=" border-b border-gray-200 pr-20 pb-[10px] text-start dark:!border-navy-700"
                        >
                          <div className="flex items-center gap-1">
                            <p className="w-10 text-xs tracking-wide text-gray-600">
                              {column.render("Header")}
                            </p>
                            <span className="text-xs text-gray-400">
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? " ↓"
                                  : " ↑"
                                : ""}
                            </span>
                          </div>
                        </th>
                      );
                    }
                    return (
                      <th
                        key={index}
                        className="border-b border-gray-200 pr-20 pb-[10px] text-start dark:!border-navy-700 "
                      >
                        <p className="w-20 text-xs tracking-wide text-gray-600">
                          {column.render("Header")}
                        </p>
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row);

                return (
                  <tr {...row.getRowProps()} key={index}>
                    {row.cells.map((cell, index) => {
                      let data = cell.render("Cell");

                      if (cell.column.Header === "Status") {
                        data = (
                          <div className="flex items-center">
                            <div className={`rounded-full text-xl`}>
                              {cell.value === true ? (
                                <MdCheckCircle className="text-green-500" />
                              ) : cell.value === false ? (
                                <MdCancel className="text-red-500" />
                              ) : cell.value === "Error" ? (
                                <MdOutlineError className="text-orange-500" />
                              ) : null}
                            </div>
                          </div>
                        );
                      } else if (cell.column.Header === "Value") {
                        data = (
                          <div className="scrollbar-custom mr-5 max-h-[150px] overflow-auto overflow-y-auto overflow-x-hidden pt-[4px] pb-[8px] sm:text-[14px]">
                            {cell.value}
                          </div>
                        );
                      } else if (cell.column.Header === "Created At") {
                        data = format(
                          new Date(cell?.value || null),
                          "yyyy-MM-dd HH:mm:ss"
                        );
                      } else if (cell.column.Header === "Actions") {
                        data = (
                          <EditOrDeleteSysPrompt
                            width="w-[68px]"
                            value={cell.value}
                            cell={cell}
                            promptFragmentsData={promptFragmentsData}
                          />
                        );
                      }

                      return (
                        <td
                          className={
                            "px-[7px] pt-[14px] pb-[8px] sm:text-[14px]"
                          }
                          {...cell.getCellProps()}
                          key={index}
                        >
                          <p
                            className={`max-w-fit ${
                              [
                                "Name",
                                "Key",
                                "Version",
                                "Value",
                                "Status",
                                "Comment",
                              ].includes(cell.column.Header)
                                ? "cursor-pointer"
                                : ""
                            } ${
                              cell.column.Header === "LLM" ? "capitalize" : ""
                            }`}
                            onClick={
                              [
                                "Name",
                                "Key",
                                "Version",
                                "Value",
                                "Status",
                                "Comment",
                              ].includes(cell.column.Header)
                                ? () => handleOpenValuesPreviewModal(cell)
                                : undefined
                            }
                          >
                            {data}
                          </p>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        {((!!tableData.length && !searchQuery) ||
          (!!filterTableData.length && searchQuery)) && (
          <div className="mt-4 flex items-center justify-between">
            <button
              onClick={() => handlePageChange("previous")}
              disabled={pageIndex === 0}
              className={`rounded-md px-4 py-2 text-sm font-medium text-white ${
                pageIndex > 0
                  ? "bg-blue-500 hover:bg-blue-600"
                  : "cursor-not-allowed bg-gray-300"
              }`}
            >
              Previous
            </button>

            <span className="text-sm text-gray-700 dark:text-white">
              Page <strong>{pageIndex + 1}</strong> of{" "}
              <strong>{totalPages}</strong>
            </span>

            <button
              onClick={() => handlePageChange("next")}
              disabled={pageIndex >= totalPages - 1}
              className={`rounded-md px-4 py-2 text-sm font-medium text-white ${
                pageIndex < totalPages - 1
                  ? "bg-blue-500 hover:bg-blue-600"
                  : "cursor-not-allowed bg-gray-300"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </Card>
  );
};

export default SystemPromptsTable;
